export const LEGACY_URL_MAP: Record<string, string> = {
  'adhd-focus-issues': '/add-adhd/',
  'allergies-respiratory': '/allergies/',
  'asthma': '/asthma/',
  'back-neck-pain': '/back-pain/',
  'bedwetting-enuresis': '/bedwetting/',
  'immune-support': '/boosting-the-immune-system/',
  'breastfeeding-latch-issues': '/breastfeeding-latch/',
  'carpal-tunnel': '/carpal-tunnel/',
  'chronic-fatigue': '/chronic-fatigue-support/',
  'colic-infant-digestive': '/colic/',
  'ear-infections': '/ear-infections/',
  'fibromyalgia': '/fibromyalgia/',
  'digestive-gi-issues': '/gi-issues/',
  'headaches-migraines': '/headaches-and-migraines/',
  'posture-tech-neck': '/better-posture/',
  'sciatica': '/sciatica/',
  'scoliosis': '/scoliosis-treatment-in-royal-oak/',
  'sleep-disorders': '/sleep-how-chiropractic-can-help/',
  'tmj-jaw-pain': '/tmj/',
  'torticollis': '/help-for-torticollis/',
  'constipation': '/constipation/',
  'cranial-work': '/cranial-work/',
  'costochondritis': '/costochondritis/',
  'depression': '/depression/',
  'down-syndrome': '/down-syndrome-and-chiropractic-care/',
  'conquering-fatigue': '/conquering-fatigue-with-chiropractic/',
  'frozen-shoulder': '/help-for-frozen-shoulders/',
  'growing-pains': '/helping-growing-pains/',
  'stress': '/stress/',
  'teens-chiropractic': '/teens-and-chiropractic/',
  'text-neck': '/text-neck/',
  'dowagers-hump': '/chiropractic-care-for-dowager-humps/',
  'eczema': '/eczema/',
  'sensory-processing-disorder': '/sensory-processing-disorder-spd/',
  'pms': '/help-for-pms-royal-oak/',
  'disc-herniation-degenerative': '/help-for-slipped-disc-royal-oak/',
};

export function getConditionUrl(slug: string): string {
  return LEGACY_URL_MAP[slug] ?? `/conditions/${slug}/`;
}
